export enum AtlasErrorCodes {
  PaymentIntentMissing = 'PaymentIntentMissing',
  DoNotHonor = 'DoNotHonor',
  CardDeclined = 'CardDeclined',
  CardExpired = 'CardExpired',
  InsufficientFunds = 'InsufficientFunds',
  ChargeAlreadyCaptured = 'ChargeAlreadyCaptured',
  CardProcessingError = 'CardProcessingError',
  InvalidCardNumber = 'InvalidCardNumber',
  MissingAgreements = 'MissingAgreements',
  CreditAccountError = 'CreditAccountError',
}

export const MobyError = {
  DeviceInactive: 'DeviceInactive',
};

export const DuplicateTransactionError = {
  DuplicateOrder: 'DuplicateOrder',
};

export const InactivityErrorInIPad = {
  CustomTimeoutError: 'CustomTimeoutError',
};
